import React, { Attributes, FC } from "react";
import { Form, SelectPicker } from "rsuite";
import { FormGroupProps } from "rsuite/esm/FormGroup/FormGroup";
import { FormControlProps } from "rsuite/esm/FormControl/FormControl";

import { TenantFeatureGroup } from "store/environments/tenants/tenant-configurations/tenant-configurations-types";

import "./Dropdown.less";
import cn from "classnames";

export interface Props extends FormGroupProps, FormControlProps, Attributes {
    title?: string;
    helpText?: string;
    placeholder?: string;
    searchable?: boolean;
    cleanable?: boolean;
    data: any[];

    container?: HTMLElement | (() => HTMLElement);

    group: TenantFeatureGroup;
}

const Group: FC<Props> = ({
    key,
    helpText,
    title,
    container,
    ...props
}: Props) => {
    return (
        <Form.Group key={key} {...props}>
            <Form.ControlLabel className={"feature-groups__label"}>
                {title}
                <Form.HelpText className={"feature-groups__help"} tooltip>
                    {helpText}
                </Form.HelpText>
            </Form.ControlLabel>

            <Form.Control
                {...props}
                accepter={SelectPicker}
                container={container}
                className={cn(
                    "vertically-aligned-picker",
                    "feature-groups__form__control",
                    "feature-groups__input--long"
                )}
            />
        </Form.Group>
    );
};

export default Group;
